import { Component, Input, Output, EventEmitter } from "@angular/core";

import { DimensionName } from "../shared/project/cards/dimension-name";

@Component({
    selector: 'dimension-label',
    templateUrl: './dimension-label.component.html',
})
export class DimensionLabel {
    @Input() dimensionName: DimensionName;
    @Input() showRemoveBtn: boolean = true;
    @Input() showCreateSingleDimCardBtn: boolean = true;

    @Output() removeClicked: EventEmitter<DimensionName> = new EventEmitter<DimensionName>();
    @Output() createSingleDimCardClicked: EventEmitter<DimensionName> = new EventEmitter<DimensionName>();

    onRemoveClicked() {
        this.removeClicked.emit(this.dimensionName);
    }

    onCreateSingleDimCardClicked() {
        this.createSingleDimCardClicked.emit(this.dimensionName);
    }
}
